export default __webpack_public_path__ + "static/1-e9a1369e3e858ed0e5984daff9e54299.jpg";